module.exports = __webpack_public_path__ + "files/3671a8d85047c7e8f4db4351cbea7c49.png";